import { render, staticRenderFns } from "./ActivityLogViewer.vue?vue&type=template&id=a010654c&scoped=true&"
import script from "./ActivityLogViewer.vue?vue&type=script&lang=js&"
export * from "./ActivityLogViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a010654c",
  null
  
)

export default component.exports